// MSAL configuration
// Note: Vite env vars are baked at build time. If these are missing in local dev/preview,
// login will fail and the app will appear to "return to the login page".
const clientId = import.meta.env.FRONTEND_AUTH_CLIENT_ID;
const authority = import.meta.env.FRONTEND_AUTH_AUTHORITY;
const redirectUri = import.meta.env.FRONTEND_AUTH_REDIRECT_URI ?? window.location.origin;

if (!clientId || !authority) {
  // Keep the app bootable so local contributors can still run it,
  // but make the failure mode obvious in the console.
  console.error("MSAL is not configured: set FRONTEND_AUTH_CLIENT_ID and FRONTEND_AUTH_AUTHORITY (and optionally FRONTEND_AUTH_REDIRECT_URI).");
}

export const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri,
  },
};

// API scope for accessing the backend
export const API_SCOPE = import.meta.env.FRONTEND_API_SCOPE ?? "api://skogforsklabbet/access_as_user";
